import {
  AppstoreOutlined,
  ClusterOutlined,
  CodeOutlined,
  DatabaseOutlined,
  DesktopOutlined,
  FileProtectOutlined,
  IdcardOutlined,
  KeyOutlined,
  LockOutlined,
  SafetyCertificateOutlined,
  TagOutlined,
  TeamOutlined,
} from "@ant-design/icons";
import { type ReactNode } from "react";

const ACCESS_TYPE_ICONS: Record<string, ReactNode> = {
  all: <AppstoreOutlined />,
  "application-segment": <AppstoreOutlined />,
  assignment: <IdcardOutlined />,
  computer: <DesktopOutlined />,
  device: <DesktopOutlined />,
  entitlement: <KeyOutlined />,
  group: <TeamOutlined />,
  identity: <IdcardOutlined />,
  membership: <TeamOutlined />,
  parent: <ClusterOutlined />,
  permission: <SafetyCertificateOutlined />,
  "permission-set": <SafetyCertificateOutlined />,
  policy: <FileProtectOutlined />,
  request: <AppstoreOutlined />,
  resource: <ClusterOutlined />,
  role: <IdcardOutlined />,
  secret: <LockOutlined />,
  session: <CodeOutlined />,
  sql: <DatabaseOutlined />,
  ssh: <CodeOutlined />,
  "stack-node": <ClusterOutlined />,
  tag: <TagOutlined />,
  team: <TeamOutlined />,
};

export const accessTypeIcon = (key: string): ReactNode =>
  ACCESS_TYPE_ICONS[key] ?? <AppstoreOutlined />;

export const ANY_ACCESS_TYPE_ICON = <AppstoreOutlined />;
